// extracted by mini-css-extract-plugin
export var screen1 = "screen1-module--screen1--f70d5";
export var screen1__container = "screen1-module--screen1__container--57691";
export var screen1__imageWrapper = "screen1-module--screen1__image-wrapper--ed85f";
export var screen1__infoCol = "screen1-module--screen1__info-col--2d4e7";
export var screen1__infoWrapper = "screen1-module--screen1__info-wrapper--13e63";
export var screen1__item = "screen1-module--screen1__item--fb959";
export var screen1__link = "screen1-module--screen1__link--68089";
export var screen1__linkWrapper = "screen1-module--screen1__link-wrapper--9266d";
export var screen1__list = "screen1-module--screen1__list--0cfd7";
export var screen1__subtitle = "screen1-module--screen1__subtitle--00004";
export var screen1__text = "screen1-module--screen1__text--d5533";
export var screen1__title = "screen1-module--screen1__title--c1bea";
export var screen1__titleWrapper = "screen1-module--screen1__title-wrapper--1572f";